module.exports = __webpack_public_path__ + "static/sport/h5-bg.2f3c902.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/football/h5/h5-bg.jpg
// module id = dcSA
// module chunks = 0